'use strict';

define('vb/private/vx/localExtensionAdapter',[
  'vb/private/vx/baseExtensionAdapter',
  'vb/private/utils',
], (BaseExtensionAdapter, Utils) => {
  /**
   * The extension adapter used to load extension from local file
   */
  class LocalExtensionAdapter extends BaseExtensionAdapter {
    /**
     * Return a promise to load the manifest given the extensionId.
     * @param  {String} extensionId the extension id
     * @return {Promise}            a promise that resolves to the manifest
     */
    loadManifest(extensionId) {
      return super.loadManifest(extensionId)
        .then(() => Utils.loadAndParse(this.registryUrl).then((registry) => {
          const reg = registry.extensions || [];
          const ref = {};
          const promises = [];

          // Reference the ui part and build the promises
          reg.forEach((ext) => {
            ref[ext.id] = ext.ui;
            promises.push(Utils.loadAndParse(`${ext.ui.baseUrl}/manifest.json`));
          });

          // Load all the vb-extension.json and insert the missing ui.baseUrl
          return Promise.all(promises).then((extensions) => {
            extensions.forEach((ext) => {
              // Insert the ui.baseUrl part in the extension
              ext.ui = {
                baseUrl: ref[ext.id].baseUrl,
              };
            });

            return { extensions };
          });
        }));
    }
  }

  return LocalExtensionAdapter;
});

